export const USER_GROUPS = {
  APPMANAGER: "AppManager",
  SUPERAPPMANAGER: "SuperAppManager",
  SOCOTECUSER: "SocotecUser",
};
